






























import { Component, Prop, Vue } from 'vue-property-decorator';
import ProsemirrorViewerInput from '@/editor/editor-block-view/components/ProsemirrorViewerInput.vue';
import { IImage } from '@/editor/types';
import { ENodeType } from '@/editor/types/enums';

@Component({
  components: {
    ProsemirrorViewerInput,
  },
})
export default class EditorNodeImage extends Vue {
  @Prop() node: IImage;
  @Prop() nodeTypeBefore: ENodeType;
  @Prop() nodeTypeAfter: ENodeType;

  startSize: number = 64;
  textFont: { size: number } = { size: 64 };

  get isHeadingSet(): boolean {
    return this.node?.heading !== '<p></p>' && !!this.node?.heading;
  }

  get isCaptionSet(): boolean {
    return this.node?.caption !== '<p></p>' && !!this.node?.caption;
  }

  get fontSize(): string {
    return `--fontSize: ${this.textFont?.size}px;`;
  }

  get imageSize(): string {
    return this.node?.imageSize?.toLowerCase();
  }

  get isTableAbove(): boolean {
    return this.nodeTypeBefore === ENodeType.Table;
  }

  get isTableBelow(): boolean {
    return this.nodeTypeAfter === ENodeType.Table;
  }

  handleImageLoaded() {
    this.textFont.size = this.startSize;

    setTimeout(() => {
      this.setTextSize();
    }, 50);
  }

  setTextSize() {
    if (!this.isHeadingSet) {
      return;
    }
    const textNode = (this.$refs.imageContent as HTMLElement).querySelector(
      '.image-heading p'
    ) as HTMLElement;
    const parentContainerWidth = (textNode.parentNode as HTMLElement).clientWidth;
    const currentTextWidth = textNode.scrollWidth;
    const currentFontSize = parseInt(window.getComputedStyle(textNode).fontSize);
    const newValue = Math.floor(
      Math.min(Math.max(8, (parentContainerWidth / currentTextWidth) * currentFontSize), 64)
    );

    this.textFont = {
      ...this.textFont,
      size: newValue,
    };
  }
}
